import { getCookie } from '../base/cookieService';

export function isDay0(created?: number) {
  if (!created) {
    return false;
  }
  const expirationDate = new Date(created * 1000);
  // add 24 hours to creation date
  expirationDate.setHours(expirationDate.getHours() + 24);
  // now should be less that created date + 24h
  return Date.now() < expirationDate.valueOf();
}

export function getCouponFromUrl() {
  const url = new URL(window.location.href);
  const coupon = url.searchParams.get('coupon');
  return coupon ?? '';
}

export const DAY0COUPON = 'D1DISC20CB';

const padNumber = (num: number) => num.toString().padStart(2, '0');

export const parseTime = (secondsLeft: number) => {
  let time = secondsLeft;
  const hours = Math.floor(secondsLeft / 3600);
  time = time - hours * 3600;
  const minutes = Math.floor(time / 60);
  const seconds = time - minutes * 60;
  return `${padNumber(hours)}:${padNumber(minutes)}:${padNumber(seconds)}`;
};

export const getSecondsUntilDay0Expire = (created?: number) => {
  if (!created) {
    return 0;
  }
  const expirationDate = new Date(created * 1000);
  // add 24 hours to creation date
  expirationDate.setHours(expirationDate.getHours() + 24);
  // calculate difference
  const diffMs = expirationDate.valueOf() - Date.now();
  return Math.trunc(diffMs / 1000);
};

const COUPON_COOKIE_NAME = 'nn_web_coupon';

export function getCouponFromCookies() {
  return getCookie(COUPON_COOKIE_NAME);
}
